// extracted by mini-css-extract-plugin
module.exports = {"addButton":"ProductAddBasket_addButton__1OUPl","label":"ProductAddBasket_label__1cZMe","clicked":"ProductAddBasket_clicked__3bCzP"};